import React from 'react';
export const Icon = ({ component: Component, width, height, alt, ariaLabel, ariaHidden, }) => {
    return (React.createElement(Component, { width: width, height: height, role: "img", alt: alt, "aria-label": ariaLabel || alt, "aria-hidden": ariaHidden }));
};
//# sourceMappingURL=Icon.js.map